import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=f6ea8ac4&scoped=true&"
import script from "./ProductProperty.vue?vue&type=script&lang=js&"
export * from "./ProductProperty.vue?vue&type=script&lang=js&"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=f6ea8ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ea8ac4",
  null
  
)

export default component.exports